import { createContext } from 'react';

import * as api from '../../../../api';

import type { AvailableSlotsData } from '../../../../components/ScheduleAppointment/AppointmentDisplay/common';
import type { Props as FilterProps } from '../../../../components/ScheduleAppointment/Filters';

export interface SchedulingContextProps extends AvailableSlotsData {
  navigateToNextPage: () => Promise<void>;
  onAppointmentSelected: (appointment: api.EhrTimeSlot.EhrTimeSlot) => void;
  practice?: api.Practice.Practice;
  encounter?: api.Encounter.Encounter;
  patientPcpPreferred?: boolean;
  filterProps?: FilterProps;
}

const defaultContext: SchedulingContextProps = {
  availableEhrTimeSlots: [],
  practices: {},
  providers: {},
  orders: {},
  navigateToNextPage: async () => {},
  onAppointmentSelected: () => {},
  fieldConfig: {
    previsitFormFieldId: '',
    label: '',
    helpDialog: '',
    scheduleAppointmentSortBy: null,
    scheduleAppointmentDisplayBy: null,
    scheduleAppointmentStartTime: null,
    scheduleAppointmentEndTime: null,
    scheduleAppointmentCallSectionEnabled: false,
    scheduleAppointmentCommentEnabled: false,
    customConfigs: {},
    fhirDynamicProviders: [],
  },
  patientOrder: undefined,
  mainProviderUserId: '',
  practice: undefined,
  encounter: undefined,
  patientPcpPreferred: false,
  filterProps: undefined,
};

export const SchedulingContext =
  createContext<SchedulingContextProps>(defaultContext);
